<template>
  <div class="loading-overlay-container">
    <!-- Opaque background -->
    <div class="loading-overlay-modal-background" />

    <!-- Inner body -->
    <div class="loading-inner-container">
      <h2 style="text-align: center; padding-bottom: 0; color: #000000;">
        {{ title }}
      </h2>
      <div
        class="subtitle"
        v-html="message"
      />
      <div
        v-if="!!secondaryAction"
        class="marginNormalTop"
      >
        <div
          v-if="!secondaryActionIsLoading && !invoiceIsLoading"
          class="colorError cursorPointer"
          @click="handleSecondaryActionClick"
        >
          {{ secondaryAction.label }}
        </div>
        <div v-else>
          <i class="fa fa-spinner fa-spin fa-2x fa-fw" />
        </div>
      </div>
      <div class="alert-buttons">
        <button
          class="continue-btn"
          @click="close()"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: 'AlertComponent',
	components: {},
	props: ['title', 'message', 'secondaryAction'],
	data () {
		return {
			secondaryActionIsLoading: false
		}
	},
	computed: {
		/**
		 * @public
		 */
		invoiceIsLoading: function () {
			return this.$store.state.invoiceIsLoading
		}
	},
	mounted () { },
	methods: {
		/**
		 * Gets called when user clicks OK button
		 * @public
		 */
		close: function () {
			this.$emit('close')
		},
		/**
		 * Gets called when user clicks secondary action
		 */
		handleSecondaryActionClick: function () {
			if (this.secondaryAction && this.secondaryAction.onClick) {
				this.secondaryActionIsLoading = true
				this.secondaryAction.onClick().then(response => {
					this.secondaryActionIsLoading = false
				})
			}
		}
	}
}
</script>

<style scoped>
.subtitle {
  color: #000000;
  padding-left: 2rem;
  padding-right: 2rem;
}
</style>
